// extracted by mini-css-extract-plugin
export default {"layout":"ReviewDownload_layout__qd1tb","name":"ReviewDownload_name__6L9m6"};